import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IContact } from 'src/services/api/contacts/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { CONTACTS_PATH } from 'src/services/api/contacts/constants';

export type IUpdateContactRequest = {
    id: number;
    name?: string | null;
    email?: string;
    /**
     * Include the key to update the phone number; an explicit null clears it.
     */
    phone_number?: string | null;
};

type IUpdateContactResponse = {
    contact: IContact;
};

export const useUpdateContact = () => {
    const queryClient = useQueryClient();

    return useMutation<IContact, IStandardErrorResponse, IUpdateContactRequest>(
        async ({ id, ...payload }) => {
            const res = await apiClient(`${CONTACTS_PATH}/${id}`, {
                method: 'patch',
                json: payload,
            }).json<IUpdateContactResponse>();

            return res.contact;
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.contacts);
            }
        }
    );
};
